<template>
  <div>
    <b-modal id="modal-delivery-shipped"
                :title="redemptionItem.deliveryStatus | statusTranslate"
                centered
                hide-footer
                no-enforce-focus>
      <div>
        <div class="status-card">
          <span v-if="!redemptionItem.deliveryStatus">
            待發貨
          </span>
          <span v-else>
              {{ redemptionItem.deliveryStatus | statusTranslate }}
          </span>
          <a href="#" @click="$bvModal.show('modal-delivery-record')"
                      class="">
              <img class="mr-2" src="../../assets/img/deliverystatus/history.svg"/>
              查看紀錄
          </a>
        </div>
        <div v-if="deliveryStatusDetail">
          <div class="detail row">
              <div class="col-4 left-col">
                速遞公司
              </div>
              <div class="col-8 right-col">
                {{ deliveryStatusDetail.company }}
              </div>
              <div class="line"></div>
          </div>
          <div class="detail row">
              <div class="col-4 left-col">
                運單編號
              </div>
              <div class="col-8 right-col">
                {{ deliveryStatusDetail.orderId }}
              </div>
              <div class="line"></div>
          </div>
        </div>
      </div>
    </b-modal>
    <DeliveryRecordModal :redemptionId="redemptionItem.id"></DeliveryRecordModal>
  </div>
</template>

<script>
import DeliveryRecordModal from '@/components/delivery-status/DeliveryRecordModal.vue';

export default {
  props: ['status', 'redemptionItem', 'role', 'deliveryStatusDetail'],
  components: {
    DeliveryRecordModal,
  },
  filters: {
    statusTranslate: (value) => {
      if (!value) return '';
      switch (value) {
        case 'DELIVERED':
          return '已發貨';
        case 'DELAYED':
          return '發貨延誤';
        default:
          return '待發貨';
      }
    },
  },
  data: () => ({
  }),
};
</script>

<style scoped lang="scss">
::v-deep {
  .status-card{
        span {
            font-weight: bold;
        }

        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid #cae4fc;
        border-radius: 4px;
        background: #f5fafe;
        min-height: 54px;
        width: 100%;
        color: #174169;
        justify-content: space-between;
        font-size: 0.9em;
    }

    .modal{
        &-dialog {
            max-width: 700px;
        }

        &-header {
            padding: 20px;
            border: none;
        }

        &-title {
            margin: 0 auto;
            font-size: 18px;
            font-weight: 400;
            color: #3a4047;
        }

        &-header .close {
            margin: 0px;
            padding: 0px;
            font-size: 20px;
        }

        &-body {
            padding: 0 24px 24px 24px;
        }

        &-body .col-12 {
            padding: 0;
            text-align: right;
        }
    }

    .action {
      text-align: right;
      width: 100%;
      padding: 0px 15px;
      button {
          width: 114px;
          height: 42px;
          display: inline-block;
          margin-left: 15px;
      }
    }

    .detail {
      padding: 15px 0px;
      color: #636D77;
        .left-col{
          color: #636D77;
          padding:10px 15px;
        }
        .right-col{
          padding:10px 15px;
          color: #3A4047;
        }
      .line {
        background-color: #e5e5e5;
        height: 1px;
        width:100%;
        margin: 0px 15px;
      }
    }

    .remarks{
        textarea{
            height: 92px;
        }
    }
}
</style>
